import Scene = Phaser.Scene;
import {SpaceTrSpace, Tr} from "@/i18n/i18n";
import Container = Phaser.GameObjects.Container;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {Force, WarriorClass} from "@/store/level/types";
import OnceCaller from "@/utils/once-caller";
import {CreatureUtils} from "@/utils/creature-utils";
import {StringUtils} from "@/utils/string-utils";
import {ForceDescription, Lang} from "@/store/player/types";
import PlayerStore from "@/store/player";

export class ForceInfoPanel extends Container {

    public static instance:ForceInfoPanel | null = null;

    constructor(scene: Scene, canvas: HTMLCanvasElement, force:Force, maxRank:number, x:number, y:number, desc: ForceDescription, isMainForce:boolean,
                showForceRanksManualCallback: (wc: WarriorClass, forcesDescription:ForceDescription, maxRank:number) => unknown){

        super(scene, x, y);
        this.setDepth(1101);
        let pointerX = 0;

        let margin = 250*CU.S;
        if(this.x < margin){
            pointerX = (x - margin)/CU.S;
            this.x = margin;
        } else if(x > (CU.CANVAS_WIDTH - margin)){
            pointerX = (x -  (CU.CANVAS_WIDTH - margin))/CU.S;
            this.x =  (CU.CANVAS_WIDTH - margin);
        }

        if(ForceInfoPanel.instance){
           ForceInfoPanel.instance.destroy()
        }
        ForceInfoPanel.instance = this;

        let y0 = -200;
        let pointer = SpriteUtils.addSprite(this.scene, pointerX, 18, Keys.UI_PROFILE_FORCES_INFO_POINTER, undefined, 1.06, 1.06);
        pointer.setOrigin(0.5, 1);
        let bg = SpriteUtils.addSprite(this.scene, 0, -200 + y0 , Keys.UI_PROFILE_FORCES_INFO_PANEL_MIDDLE, undefined, 1.06,1.06)//1.1, 1.06);
        bg.setOrigin(0.5, 0);
        let bgEdgeBottom = SpriteUtils.addSprite(this.scene, 0, 10 + y0, Keys.UI_PROFILE_FORCES_INFO_PANEL_EDGE, undefined, 1.06,1.06);
        bgEdgeBottom.setOrigin(0.5, 0);
        let bgEdgeTop = SpriteUtils.addSprite(this.scene, 0, -200-75 + y0, Keys.UI_PROFILE_FORCES_INFO_PANEL_EDGE, undefined, 1.06,-1.06);
        bgEdgeTop.setOrigin(0.5, 1);

        let forceImage = SpriteUtils.addSprite(this.scene, -440 * 0.38, - 459 * 0.855,
            CreatureUtils.getForceAtlasLarge(force.warriorClass), CreatureUtils.getLargeForceIcon(force.warriorClass, true), 0.9, 0.9);

        let isMaxRang = force.level >= maxRank;//desc.descriptions.length;

        let forceName =  PlayerStore.getPlayer().lang == Lang.RU ?
            StringUtils.capitalizeFirstLetter(Tr('force')) + ' ' + StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(force.warriorClass)) :
            StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(force.warriorClass)) + ' ' + StringUtils.capitalizeFirstLetter(Tr('force'));
        if(isMainForce){
            forceName = StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameFull(force.warriorClass))
        }

        let isLongName = forceName.length > 16;

        let forceLabel = TextUtils.addTextAdvanced(scene, forceName, forceImage.x/CU.S + 85, forceImage.y / CU.S - 30,
            '#d72834', isLongName? 17 : 21, 'normal', 480, 'center', 2,  Fonts.MYRIADPRO_REGULAR);
        forceLabel.setStroke('#1d0709', 5)
        forceLabel.setOrigin(0, 0.5);

        let linerOffset = forceLabel.width/CU.S > 130?  50 : 25;
        let redLiner = SpriteUtils.addImage(this.scene, forceImage.x/CU.S + 85 - linerOffset, forceImage.y / CU.S - 30,
            Keys.UI_RED_LINER, undefined, (forceLabel.width/CU.S + linerOffset * 2)/361, 1);
        redLiner.setOrigin(0, 0.5);

        let forceRang = TextUtils.addTextAdvanced(scene, StringUtils.capitalizeFirstLetter(Tr('rang')) + ' ' + force.level, forceImage.x/CU.S + 85, forceImage.y / CU.S  - 0,
            '#b48c54', 19, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);
        forceRang.setStroke('#1c0e0e', 5)
        forceRang.setOrigin(0, 0.5);

        let descriptions:Phaser.GameObjects.Text[] = [];
        let dots:Phaser.GameObjects.Image[] = [];
        this.prepareDescription(desc.descriptions[force.level-1]).forEach((desc, index) => {
            let height = descriptions.reduce((acc, d) => acc + d.height/CU.S, 0);
            let forceDesc = TextUtils.addTextAdvanced(scene, desc, forceImage.x/CU.S - 58 + 39, forceImage.y / CU.S  + 33 + height + index * 13,
                '#a9a8a1', 15, 'normal', 400, 'left', 2, Fonts.MYRIADPRO_REGULAR);
            forceDesc.setOrigin(0, 0);
            if(index != 0){
                let goldDot = SpriteUtils.addSprite(this.scene, forceImage.x/CU.S - 58 + 30 - 10, forceImage.y / CU.S  + 33 + height + index * 13 + 12,
                    Keys.UI_GOLD_DOT, undefined, 1, 1);
                dots.push(goldDot);
            }
            descriptions.push(forceDesc);
        })

        let forceDescHeight = descriptions.reduce((acc, d) => acc + d.height/CU.S, 0) + (descriptions.length - 1)*13;
        let bottomDeltaY = forceDescHeight - 150 + 25 // (forceDescHeight > 125? forceDescHeight - 125 : 0) + 20;
        let bgBottom = SpriteUtils.addSprite(this.scene, 0, 20 + bottomDeltaY - 214-5-10, Keys.UI_PROFILE_FORCES_INFO_PANEL_BOTTOM, undefined, 1, 1.06);
        bgBottom.setOrigin(0.5, 0);
        // bgBottom.alpha = 0.2;

        // let forceDesc = new BBCodeText(scene, forceImage.x/CU.S - 58, forceImage.y / CU.S  + 53, this.prepareDescription(desc.descriptions[force.level-1]), {
        //     fontFamily: Fonts.MYRIADPRO_REGULAR,
        //     fontSize: '15pt',
        //     wrap: {
        //         mode: 1,
        //         width: 460
        //     },
        //     align: 'left',
        //     fontStyle: 'oblique'
        // }).setScale(CU.S, CU.S);
        // forceDesc.setOrigin(0, 0);

        let questionIcon = SpriteUtils.addImage(this.scene!, forceLabel.getRightCenter().x! / CU.S + 24,
            forceLabel.getRightCenter().y! / CU.S , Keys.ATLAS_UI, Keys.UI_STAT_MINE_CIRCLE, 1.5)
        questionIcon.setInteractive().on('pointerup', function(pointer: any) {
            OnceCaller.doOnce('forceManual', () => {
                showForceRanksManualCallback(force.warriorClass, desc, maxRank);
            });
        });

        this.add([bg, bgEdgeBottom, bgEdgeTop, bgBottom, pointer, redLiner, forceImage, forceLabel, forceRang, questionIcon, ...descriptions, ...dots]);

        let bottomDeltaY2 = 0;
        if(isMaxRang){
            let goldenCheck = SpriteUtils.addImage(this.scene!, -440 * 0.33, - 459 * 0.32 + 10 + bottomDeltaY, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK);
            goldenCheck.alpha = 0.5;

            let maxRang = TextUtils.addTextAdvanced(scene, Tr('force.has.max.rang'), -440 * 0.33 + 50, - 459 * 0.32+ 10 + bottomDeltaY,
                '#816832', 19, 'normal', 250, 'center', 2, Fonts.MYRIADPRO_REGULAR);
            maxRang.setOrigin(0, 0.5);

            bottomDeltaY2 = -60;

            this.add([maxRang, goldenCheck]);
        } else {
            bottomDeltaY += 20
            let nextRang = TextUtils.addTextAdvanced(scene, Tr('next.rang'), 5, - 459 * 0.479+ 8-10 + bottomDeltaY,
                // '#6c4f54', 16, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);
                '#7a6565', 16, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);
            nextRang.setOrigin(0.5, 0);
            nextRang.setShadowOffset(0,0);
            // nextRang.setShadowColor('#212123');
            nextRang.setStroke('#212123', 4)

            let forceImage2 = SpriteUtils.addSprite(this.scene, -440 * 0.38, - 459 * 0.35 -10+ 13 + bottomDeltaY,
                CreatureUtils.getForceAtlasLarge(force.warriorClass), CreatureUtils.getLargeForceIcon(force.warriorClass, true), 0.7, 0.7);
            forceImage2.alpha = 0.4;

            let forceBlackBg = SpriteUtils.addSprite(this.scene, -440 * 0.38, - 459 * 0.35 -10+ 13+ bottomDeltaY,
                Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_BLACK_BG, 0.7, 0.7);
            forceBlackBg.alpha = 0.9;

            let forceLabel2 = TextUtils.addTextAdvanced(scene, forceName, forceImage2.x/CU.S + 60, forceImage2.y / CU.S - 0,
                '#8a1e25', isLongName? 15 : 18, 'normal', 480, 'center', 2,  Fonts.MYRIADPRO_REGULAR);
            forceLabel2.setStroke('#1d0709', 4)
            forceLabel2.setOrigin(0, 0.5);

            let linerOffset = forceLabel2.width/CU.S > 130?  50 : 25;
            let redLiner2 = SpriteUtils.addImage(this.scene, forceLabel2.x/CU.S - linerOffset, forceLabel2.y / CU.S,
                Keys.UI_RED_LINER, undefined, (forceLabel2.width/CU.S + linerOffset * 2)/361, 0.8);
            redLiner2.setOrigin(0, 0.5);
            redLiner2.alpha = 0.5;

            let forceRang2 = TextUtils.addTextAdvanced(scene, StringUtils.capitalizeFirstLetter(Tr('rang')) + ' ' + (force.level + 1), forceImage2.x/CU.S + 60, forceImage2.y / CU.S  + 28,
                '#7e623a', 14, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);
            forceRang2.setOrigin(0, 0.5);
            forceRang2.setStroke('#1c0e0e', 4)

            let descriptions2:Phaser.GameObjects.Text[] = [];
            let dots2:Phaser.GameObjects.Image[] = [];
            this.prepareDescription(desc.descriptions[force.level]).forEach((desc, index) => {
                let height = descriptions2.reduce((acc, d) => acc + d.height/CU.S, 0);
                let forceDesc = TextUtils.addTextAdvanced(scene, desc, forceImage2.x/CU.S - 50 + 30 + 9, forceImage2.y / CU.S  + 20 + height + index * 13,
                    '#797973', 14, 'normal', 400, 'left', 2, Fonts.MYRIADPRO_REGULAR);
                forceDesc.setOrigin(0, 0);

                if(index != 0) {
                    let goldDot = SpriteUtils.addSprite(this.scene, forceImage2.x / CU.S - 50 + 30 - 10, forceImage2.y / CU.S + 20 + height + index * 13 + 12,
                        Keys.UI_GOLD_DOT, undefined, 1, 1);
                    dots2.push(goldDot);
                }

                descriptions2.push(forceDesc);
            })

            let forceDescHeight2 = descriptions2.reduce((acc, d) => acc + d.height/CU.S, 0) + (descriptions2.length - 1)*13;
            bottomDeltaY2 = forceDescHeight2 - 90 // (forceDescHeight > 125? forceDescHeight - 125 : 0) + 20;

            let questionIcon2 = SpriteUtils.addImage(this.scene!, forceLabel2.getRightCenter().x! / CU.S + 18, forceLabel2.getRightCenter().y! / CU.S,
                Keys.ATLAS_UI, Keys.UI_STAT_MINE_CIRCLE, 1.2)
            questionIcon2.setInteractive().on('pointerup', function(pointer: any) {
                OnceCaller.doOnce('forceManual', () => {
                    showForceRanksManualCallback(force.warriorClass, desc, maxRank);
                });
            });
            questionIcon2.alpha = 0.7;

            this.add([redLiner2, forceLabel2, forceRang2, questionIcon2, forceBlackBg, forceImage2, nextRang, ...descriptions2, ...dots2]);
        }

        this.y -= (bottomDeltaY + bottomDeltaY2) * CU.S;
        bg.setScale(1.06 * CU.S, (350 + (bottomDeltaY + bottomDeltaY2)) / 44 * CU.S);

        bgEdgeBottom.y = y - ( this.y/CU.S + 74 - 15) * CU.S;
        pointer.y = y - ( this.y/CU.S - 7 - 15) * CU.S;
        bg.setInteractive();
        bgEdgeBottom.setInteractive();
        bgEdgeTop.setInteractive();

        OnceCaller.doOnce('forceInfoPanel', () => {
            scene.input.on('pointerup', () => {
                OnceCaller.doOnce('forceInfoPanel', () => {
                    scene.time.delayedCall(10, () => {
                        if (ForceInfoPanel.instance) {
                            ForceInfoPanel.instance.destroy()
                            ForceInfoPanel.instance = null;
                        }
                    });
                }, 100);
            });
        }, 100);
    }

    private prepareDescription(descText: string): string[] {
        let versions = descText.split('[long]');
        descText = versions[0].trim();

        descText = descText.replace('[g]', '[color=#e0a141]');
        descText = descText.replace('[r]', '[color=#6e3c3c]');
        descText = descText.replace('[v]', '[color=#71d565]');
        descText = descText.replace('[/g]', '[/color]');
        descText = descText.replace('[/r]', '[/color]');
        descText = descText.replace('[/v]', '[/color]');

        let dot = '•';
        descText = descText.trim()
        descText = descText.toLowerCase()
        let parts = descText.split('\n');
        descText = parts.map(part => StringUtils.capitalizeFirstLetter(part.trim())).join("\n" + dot + " ")
        descText =  dot + " " + descText;
        // return descText;
        return descText.split('•');
    }

}
